export enum ETelaSistema {
    PainelNegocio = 'Painel de Negócio',
    VisualisarLog = 'Visualizar Log',
    UsuarioOnline = 'Usuário Online',
    AtivoBolsa = 'Ativos Bolsa',
    PermissoesAcesso = 'Permissões de Acesso',
    Usuarios = 'Usuários',
    AtualizarCpf = 'Atualizar CPF',
    ImportarArquivo = 'Importar Arquivo',
    Cliente = 'Cliente',
    Relatorio = 'Relatório',
    SolicitacoesDocumento = 'Solicitações de Documento',
    // CadastroAcionista = 'Cadastro Cliente',
    PerfilUsuario = 'Perfil',
    PainelOperacional = 'Painel Operacional',
    AcompanhamentoProcesso = 'Acompanhamento de Processo'
}
